import AuthService from "../Services/authService";

export class userHelper
{
	static isAdmin()
	{
		return AuthService.getInstance().GetLoggedInUser().roles.includes("Admin");
	}

	static doesUserHaveRole(rolesArray)
	{
		let userRoles=AuthService.getInstance().GetLoggedInUser().roles;
		for (const role of rolesArray) 
		{
			if(userRoles.includes(role)) return true;
		}
		
		return false;
	}

}

export default userHelper;